import React, { Component } from "react";
import styled from "styled-components";
import Icon from "@alboompro/boom-components/general/icon";

const SelectItem = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: 1px;
  padding: 7px 3px 7px 30px;
  flex: 1;
  display: flex;
  align-items: center;
  ${props => props.selected && "background-color: #E5F3FD;"};

  &:hover {
    cursor: pointer;
    background-color: #E5F3FD;
  }
`;

const SelectLabel = styled.span`
  flex: 1;
  color: #434343;
  font-size: 12px;
`;

const SelectDesc = styled.span`
  font-size: 12px;
  color: #aeaeae;
`;

const SelectedIcon = styled.span`
  position: absolute;
  left: 5%;
  top: 19%;
`;

class OptionItem extends Component {
  clickHandler = () => {
    const { onClick, value } = this.props;
    onClick(value);
  };

  renderLabel = () => {
    const { label, style, locale } = this.props;
    return (
      <span style={style}>
        {typeof label === "string" ? label : label[locale]}
      </span>
    );
  };

  render() {
    const { selected, value, suffix } = this.props;
    const isSelected = selected === value;

    return (
      <SelectItem onClick={this.clickHandler} selected={isSelected}>
        <SelectedIcon>
          {isSelected && (
            <Icon
              kind="bold"
              group="interface-essential"
              category="form-validation"
              file="check.svg"
              size="17"
              color="#44ADF8"
            />
          )}
        </SelectedIcon>
        <SelectLabel>{this.renderLabel()}</SelectLabel>
        {suffix && <SelectDesc>{suffix}</SelectDesc>}
      </SelectItem>
    );
  }
}

export default OptionItem;
